import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

export interface ToggleOpcion {
  valor: string;
  etiqueta: string;
  icono?: string; // nombre de mat-icon, opcional
}

@Component({
  selector: 'app-toggle-opciones',
  templateUrl: './toggle-opciones.component.html',
  styleUrls: ['./toggle-opciones.component.css'],
})
export class ToggleOpcionesComponent {
  @Input() opciones: ToggleOpcion[] = [];
  @Input() seleccion = '';

  /** Si se define, persiste la selección en sessionStorage bajo esta key. */
  @Input() storageKey?: string;

  @Input() variante: 'horizontal' | 'columna' = 'horizontal';

  @Output() seleccionChange = new EventEmitter<string>();

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    if (this.storageKey) {
      const guardado = sessionStorage.getItem(this.storageKey);
      if (guardado && this.opciones.some((o) => o.valor === guardado)) {
        this.seleccion = guardado;
      }
    }
  }

  get indice(): number {
    const i = this.opciones.findIndex((o) => o.valor === this.seleccion);
    return i < 0 ? 0 : i;
  }

  seleccionar(opcion: ToggleOpcion): void {
    if (opcion.valor === this.seleccion) return;

    this.seleccion = opcion.valor;
    this.seleccionChange.emit(opcion.valor);

    if (this.storageKey) {
      sessionStorage.setItem(this.storageKey, opcion.valor);
    }

    this.reiniciarHalo();
  }

  trackByValor(_index: number, opcion: ToggleOpcion): string {
    return opcion.valor;
  }

  /** Fuerza el reflow para que la animación del halo se repita en cada clic. */
  private reiniciarHalo(): void {
    const indicador = this.el.nativeElement.querySelector(
      '.toggle-indicador'
    ) as HTMLElement | null;
    if (!indicador) return;

    indicador.classList.remove('animar-halo');
    void indicador.offsetWidth; // fuerza reflow
    indicador.classList.add('animar-halo');
  }
}